import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../provider/AuthContext';

function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <div className='text-muted small'>Authenticating....</div>;
  if (!isAuthenticated) return <Navigate to='/login' replace state={{ from: location.pathname }} />;

  return children;
}

export default RequireAuth;
